import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Link, Typography } from '@mui/material';
import { DisclosureTooltip } from '@repo/ui/DisclosureTooltip';
import { StarIcon } from './components/StarIcon';

type Props = {
  starRating?: number;
  starRatingTooltip?: string;
  reviewLink?: string;
  hideLabel?: boolean;
  tooltipColor?: string;
  iconSize?: number | { xs: number; md: number };
  tooltipIconColor?: string;
};

export const NumericLayout = ({
  starRating,
  starRatingTooltip,
  reviewLink,
  hideLabel = false,
  tooltipColor = 'black',
  iconSize = 24,
  tooltipIconColor = 'black',
}: Props) => {
  if (!starRating)
    return (
      <Typography variant="textSmall" sx={{ display: 'block', color: 'neutral.dark' }}>
        <StarIcon
          color="#D8D9DA"
          additionalStyles={{
            width: iconSize,
            height: iconSize,
            verticalAlign: 'bottom',
          }}
        />{' '}
        Not yet rated
      </Typography>
    );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'inline-block', alignItems: 'center' }}>
        {!hideLabel && (
          <Typography variant="textSmall" color="text.secondary" paddingRight={0.5}>
            NerdWallet rating
          </Typography>
        )}
        {starRatingTooltip && (
          <DisclosureTooltip
            tooltipStyleOverride={{
              lineHeight: 1,
              maxWidth: '265px',
            }}
            trigger={
              <Link
                aria-label="NerdWallet rating info"
                component="button"
                color="text.primary"
                variant="textSmall"
                lineHeight={1}
              >
                <HelpOutlineIcon sx={{ color: tooltipIconColor }} />
              </Link>
            }
          >
            <Typography variant="textSmall" color={tooltipColor}>
              {starRatingTooltip}
            </Typography>
          </DisclosureTooltip>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          fontSize: 24,
          marginRight: 0.5,
        }}
      >
        <StarIcon
          additionalStyles={{
            height: iconSize,
            width: iconSize,
            marginRight: '5px',
          }}
        />
        {reviewLink ? (
          <Link
            href={reviewLink}
            target="_blank"
            rel="noopener"
            sx={{ typography: { xs: 'bodyLarge', md: 'bodyExtraLarge' } }}
          >
            {starRating?.toFixed(1)}
          </Link>
        ) : (
          starRating?.toFixed(1)
        )}
        <Typography
          variant="textSmall"
          sx={{ color: 'text.secondary', paddingTop: 1, paddingLeft: 0.5 }}
        >
          /5
        </Typography>
      </Box>
    </Box>
  );
};
